// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `media-swiper .slides-container {
  position: relative;
}
media-swiper .slides-container .slide {
  width: 100%;
  flex-shrink: 0;
}
media-swiper .slides-container .slide a.disabled {
  pointer-events: none;
  cursor: default;
}
media-swiper .slides-container .slide .overlay {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 4vw;
  padding-top: max(4vw, 130px);
  box-sizing: border-box;
  justify-content: center;
  align-items: flex-start;
}
media-swiper .slides-container .slide .overlay > * {
  opacity: 0;
}
media-swiper .slides-container .slide .overlay.swipe-enabled {
  cursor: grab;
}
media-swiper .slides-container .slide .overlay.light-bg {
  background: linear-gradient(transparent 70%, white);
}
media-swiper .slides-container .slide .overlay.dark-bg {
  background: linear-gradient(transparent 70%, black);
}
media-swiper .slides-container .slide .overlay.show-items > * {
  opacity: 1;
  transition: 0.3s opacity;
}
media-swiper .slides-container .slide .overlay .title {
  height: 35%;
  margin: var(--motes-padding) 0;
  object-fit: contain;
}
media-swiper .slides-container .slide .overlay .sh-original {
  height: 8%;
  object-fit: contain;
}
media-swiper .slides-container .slide .overlay button {
  margin-bottom: 1em;
}
media-swiper .slides-container .slide .overlay p {
  line-height: inherit;
  margin-top: var(--motes-padding);
}
media-swiper .slides-container .slide .overlay .icons {
  display: grid;
  grid-template-columns: repeat(4, auto);
  column-gap: var(--large-spacing);
  row-gap: var(--large-spacing);
  margin-bottom: var(--small-spacing);
}
media-swiper .slides-container .slide .overlay .icons p {
  margin: 0;
  font-size: 14px;
}
media-swiper .slides-container .slide .overlay .icons svg-icon {
  margin-right: var(--mini-spacing);
  font-size: 16px;
}
media-swiper .slides-container .slides-position {
  text-align: center;
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}
media-swiper .slides-container .slides-position .position-dot {
  display: inline-block;
  border-radius: 100%;
  width: 10px;
  height: 10px;
  margin: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  transition: 0.5s;
  border: 1px solid white;
  cursor: pointer;
}
media-swiper .slides-container .slides-position .position-dot.selected {
  background: white;
}
media-swiper .slides-container .mobile, media-swiper .slides-container .slide .overlay .mobile {
  display: none;
}
@media only screen and (max-width: 600px) {
  media-swiper .slides-container .slide .overlay {
    align-items: center;
    padding-top: 130px;
    padding-bottom: 0;
  }
  media-swiper .slides-container .slide .overlay .title {
    width: 100%;
    height: initial;
  }
  media-swiper .slides-container .slide .overlay .sh-original {
    height: 5%;
  }
  media-swiper .slides-container .slide .overlay a {
    flex-grow: 1;
    display: flex;
    align-items: flex-end;
  }
  media-swiper .slides-container .slide .overlay .icons.mobile {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  media-swiper .slides-container .slide .overlay .icons.mobile p {
    width: 30%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  media-swiper .slides-container .slide .overlay .icons.mobile p:last-of-type {
    text-align: right;
  }
  media-swiper .slides-container .mobile, media-swiper .slides-container .slide .overlay .mobile {
    display: initial;
  }
  media-swiper .slides-container .desktop, media-swiper .slides-container .slide .overlay .desktop {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/media-swiper/media-swiper.component.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;AADR;AAGQ;EACI,WAAA;EACA,cAAA;AADZ;AAGY;EACI,oBAAA;EACA,eAAA;AADhB;AAIY;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;AAFhB;AAIgB;EACI,UAAA;AAFpB;AAKgB;EACI,YAAA;AAHpB;AAMgB;EACI,mDAAA;AAJpB;AAOgB;EACI,mDAAA;AALpB;AAQgB;EACI,UAAA;EACA,wBAAA;AANpB;AASgB;EACI,WAAA;EACA,8BAAA;EACA,mBAAA;AAPpB;AAUgB;EACI,UAAA;EACA,mBAAA;AARpB;AAWgB;EACI,kBAAA;AATpB;AAYgB;EACI,oBAAA;EACA,gCAAA;AAVpB;AAagB;EACI,aAAA;EACA,sCAAA;EACA,gCAAA;EACA,6BAAA;EACA,mCAAA;AAXpB;AAaoB;EACI,SAAA;EACA,eAAA;AAXxB;AAcoB;EACI,iCAAA;EACA,eAAA;AAZxB;AAkBQ;EACI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;AAhBZ;AAkBY;EACI,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;AAhBhB;AAmBY;EACI,iBAAA;AAjBhB;AAqBQ;EACI,aAAA;AAnBZ;AAwBI;EAGY;IACI,mBAAA;IACA,kBAAA;IACA,iBAAA;EAxBlB;EA0BkB;IACI,WAAA;IACA,eAAA;EAxBtB;EA2BkB;IACI,UAAA;EAzBtB;EA4BkB;IACI,YAAA;IACA,aAAA;IACA,qBAAA;EA1BtB;EA6BkB;IACI,aAAA;IACA,8BAAA;IACA,WAAA;EA3BtB;EA6BsB;IACI,UAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EA3B1B;EA6B0B;IACI,iBAAA;EA3B9B;EAkCU;IACI,gBAAA;EAhCd;EAmCU;IACI,aAAA;EAjCd;AACF","sourcesContent":["media-swiper {\n\n    .slides-container {\n        position: relative;\n\n        .slide {\n            width: 100%; // Necessary for prerendered images to apprear\n            flex-shrink: 0;\n\n            a.disabled {\n                pointer-events: none;\n                cursor: default;\n            }\n\n            .overlay {\n                position: absolute;\n                z-index: 1;\n                display: flex;\n                flex-direction: column;\n                height: 100%;\n                width: 100%;\n                padding: 4vw;\n                padding-top: max(4vw, 130px);\n                box-sizing: border-box;\n                justify-content: center;\n                align-items: flex-start;\n\n                > * {\n                    opacity: 0;\n                }\n                \n                &.swipe-enabled {\n                    cursor: grab;\n                }\n\n                &.light-bg {\n                    background: linear-gradient(transparent 70%, white);\n                }\n\n                &.dark-bg {\n                    background: linear-gradient(transparent 70%, black);\n                }\n\n                &.show-items > * {\n                    opacity: 1;\n                    transition: 0.3s opacity;\n                }\n                \n                .title {\n                    height: 35%;\n                    margin: var(--motes-padding) 0;\n                    object-fit: contain;\n                }\n\n                .sh-original {\n                    height: 8%;\n                    object-fit: contain;\n                }\n\n                button {\n                    margin-bottom: 1em;\n                }\n\n                p {\n                    line-height: inherit;\n                    margin-top: var(--motes-padding);\n                }\n\n                .icons {\n                    display: grid;\n                    grid-template-columns: repeat(4, auto);\n                    column-gap: var(--large-spacing);\n                    row-gap: var(--large-spacing);\n                    margin-bottom: var(--small-spacing);\n\n                    p {\n                        margin: 0;\n                        font-size: 14px;\n                    }\n\n                    svg-icon {\n                        margin-right: var(--mini-spacing);\n                        font-size: 16px;\n                    }\n                }\n            }\n        }\n        \n        .slides-position {\n            text-align: center;\n            position: absolute;\n            bottom: 10px;\n            left: 50%;\n            transform: translateX(-50%);\n            z-index: 2;\n\n            .position-dot {\n                display: inline-block;\n                border-radius: 100%;\n                width: 10px;\n                height: 10px;\n                margin: 5px;\n                box-shadow: 0 0 5px rgb(0 0 0 / 30%);\n                transition: .5s;\n                border: 1px solid white;\n                cursor: pointer;\n            }\n\n            .position-dot.selected {\n                background: white;\n            }\n        }\n\n        .mobile, .slide .overlay .mobile {\n            display: none;\n        }\n    }\n\n    // Mobile view\n    @media only screen and (max-width: 600px) {\n        .slides-container {\n            .slide {\n                .overlay {\n                    align-items: center;\n                    padding-top: 130px;\n                    padding-bottom: 0;\n\n                    .title {\n                        width: 100%;\n                        height: initial;\n                    }\n\n                    .sh-original {\n                        height: 5%;\n                    }\n\n                    a {\n                        flex-grow: 1;\n                        display: flex;\n                        align-items: flex-end;\n                    }\n                    \n                    .icons.mobile {\n                        display: flex;\n                        justify-content: space-between;\n                        width: 100%;\n\n                        p {\n                            width: 30%;\n                            white-space: nowrap;\n                            text-overflow: ellipsis;\n                            overflow: hidden;\n\n                            &:last-of-type {\n                                text-align: right;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .mobile, .slide .overlay .mobile {\n                display: initial;\n            }\n\n            .desktop, .slide .overlay .desktop {\n                display: none;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
